<template>
    <div style="width: 1100px" class="qtkTd">
        <tr height="20" style='height:30.00pt;'>
        </tr>
        <tr height="27" style='height:20.25pt;'>
            <td class="qtk65" height="27" width="960" colspan="11"
                style='height:20.25pt;width:720.00pt;border-right:none;border-bottom:none;' x:str>
            </td>
        </tr>
        <tr height="27" style='height:20.25pt;'>
            <td class="qtk65" height="27" colspan="11" style='height:20.25pt;border-right:none;border-bottom:none;'
                x:str>教师教学质量听课评价表</td>
        </tr>
        <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
            <td class="qtk67" height="26.67" colspan="4" style='height:20.00pt;border-right:none;border-bottom:none;'
                x:str>
                {{tkQueData.basicInfo.xnxqmc}}
            </td>
            <td class="qtk68" colspan="7" style='border-right:none;border-bottom:none;' x:str>
                {{tkQueData.basicInfo.jslx}}
            </td>
        </tr>
        <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
            <td class="qtk69" height="26.67" colspan="2"
                style='height:20.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                教师姓名</td>
            <td class="qtk70" x:str>
                {{tkQueData.basicInfo.jsxm}}
            </td>
            <td class="qtk71" rowspan="2"
                style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>课程名称
            </td>
            <td class="qtk70" rowspan="2"
                style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                {{tkQueData.basicInfo.kcmc}}
            </td>
            <td class="qtk69" rowspan="2"
                style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>课程类型
            </td>
            <td class="qtk72" colspan="5" rowspan="2"
                style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;text-align: center;'
                x:str>
                {{tkQueData.basicInfo.tkkclx}}
            </td>
        </tr>
        <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
            <td class="qtk69" height="26.67" colspan="2"
                style='height:20.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                教师所在系部</td>
            <td class="qtk70" x:str>{{tkQueData.basicInfo.jsxbmc}}</td>
        </tr>
        <tr height="53.33" style='height:40.00pt;mso-height-source:userset;mso-height-alt:800;'>
            <td class="qtk69" height="53.33" colspan="2"
                style='height:40.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                听课班级</td>
            <td class="qtk70" x:str>
                {{tkQueData.basicInfo.tkbjmc}}
            </td>
            <td class="qtk71" x:str>听课地点</td>
            <td class="qtk70" x:str>
                {{tkQueData.basicInfo.jsmc}}
            </td>
            <td class="qtk75" x:str>听课时间<br />(日期节次)</td>
            <td class="qtk70" colspan="5"
                style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                {{tkQueData.basicInfo.tksj}}
            </td>
        </tr>
        <tr height="53.33" style='height:40.00pt;mso-height-source:userset;mso-height-alt:800;'>
            <td class="qtk69" height="53.33" colspan="2"
                style='height:40.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                应到学生数</td>
            <td class="qtk70" x:str>{{tkQueData.basicInfo.ydxss}}</td>
            <td class="qtk71" x:str>实到学生数</td>
            <td class="qtk70" x:str>
                {{tkQueData.basicInfo.sdxss}}
            </td>
            <td class="qtk76" x:str>迟到学生数</td>
            <td class="qtk70" colspan="5"
                style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                {{tkQueData.basicInfo.cdxss}}
            </td>
        </tr>
        <tr height="19" style='height:14.25pt;'>
            <td class="qtk69" height="38" rowspan="2"
                style='height:28.50pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                评价项目</td>
            <td class="qtk69" colspan="5" rowspan="2"
                style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>评价指标
            </td>
            <td class="qtk69" colspan="4"
                style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>评分标准
            </td>
            <td class="qtk69" x:str>得分</td>
        </tr>
        <tr height="19" style='height:14.25pt;'>
            <td class="qtk69" x:str>优</td>
            <td class="qtk69" x:str>良</td>
            <td class="qtk69" x:str>中</td>
            <td class="qtk69" x:str>差</td>
            <td class="qtk83"></td>
        </tr>

        <template v-for="(item,index) in tkQueData.pjxInfo">
            <tr height="57" style='height:42.75pt;'>
                <td class="qtk75" height="57" style='height:42.75pt;' x:str>
                    {{item.pjxmc}}<br />({{item.qz}}分)
                </td>
                <td class="qtk77" colspan="5"
                    style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                    {{item.pjxnr}}
                </td>
                <td class="qtk75" x:str>
                    <div v-html="item.y" />
                </td>
                <td class="qtk75" x:str>
                    <div v-html="item.l" />
                </td>
                <td class="qtk75" x:str>
                    <div v-html="item.z" />
                </td>
                <td class="qtk83" x:str>
                    <div v-html="item.c" />
                </td>
                <td class="qtk84" x:str>
                    {{item.pf}}
                </td>
            </tr>
        </template>

        <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
            <td class="qtk78" height="26.67" colspan="10"
                style='height:20.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                合<span style='mso-spacerun:yes;'>&nbsp;&nbsp; </span>计</td>
            <td class="qtk83">{{tkQueData.hjdf}}</td>
        </tr>
        <tr height="19" style='height:14.25pt;'>
            <td class="qtk77" height="38" colspan="11" rowspan="2"
                style='border-bottom:none;height: 500px;' x:str>综合评价与建议:<br />
                <span v-html="tkQueData.basicInfo.zhpjjy"></span>
            </td>
        </tr>
        <tr height="19" style='height:14.25pt;' />
        <tr height="19" style='height:14.25pt;'>
            <td class="qtk80" height="19" style='height:14.25pt;'></td>
            <td colspan="4" style='mso-ignore:colspan;'></td>
            <td x:str>评价人:</td>
            <td class="qtk68" colspan="4" style='border-right:none;border-bottom:none;' x:str>
                {{tkQueData.basicInfo.cjr}}
            </td>
            <td class="qtk85"></td>
        </tr>
        <tr height="19" style='height:14.25pt;'>
            <td class="qtk81" height="19" style='height:14.25pt;'></td>
            <td class="qtk82" colspan="4" style='mso-ignore:colspan;'></td>
            <td class="qtk82" x:str>日<span style='mso-spacerun:yes;'>&nbsp; </span>期:</td>
            <td class="qtk88" colspan="4" style='border-right:none;border-bottom:.5pt solid windowtext;' x:str>
                {{tkQueData.basicInfo.cjsj}}
            </td>
            <td class="qtk87"></td>
        </tr>

        <tr height="57" style='height:42.75pt;mso-tkrowspan:3;'>
            <td height="57" colspan="11" style='height:42.75pt;mso-ignore:colspan;'></td>
        </tr>
        <tr height="19" style='height:14.25pt;'>
            <td class="qtk89" height="19" colspan="11"
                style='height: 500px;' x:str>
                教学过程组织和主要内容:<br />
                <span v-html="tkQueData.basicInfo.jxnrgc"></span>
            </td>
        </tr>

        <tr height="20" style='height:30.00pt;'>
        </tr>
    </div>
</template>

<script>
    export default {
        props: ['tkQueData'],
    };
</script>
<style>
    .styleQueTk {
        mso-number-format: "General";
        text-align: general;
        vertical-align: middle;
        white-space: nowrap;
        mso-rotate: 0;
        mso-pattern: auto;
        mso-background-source: auto;
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: 宋体;
        mso-generic-font-family: auto;
        mso-font-charset: 134;
        border: none;
        mso-protection: locked visible;
        mso-style-name: "常规";
        mso-style-id: 0;
    }

   .qtkTd {
        mso-style-parent: styleQueTk;
        padding-top: 1px;
        padding-right: 1px;
        padding-left: 1px;
        mso-ignore: padding;
        mso-number-format: "General";
        text-align: general;
        vertical-align: middle;
        white-space: nowrap;
        mso-rotate: 0;
        mso-pattern: auto;
        mso-background-source: auto;
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: 宋体;
        mso-generic-font-family: auto;
        mso-font-charset: 134;
        border: none;
        mso-protection: locked visible;
    }

    .qtk65 {
        mso-style-parent: styleQueTk;
        text-align: center;
        font-size: 16.0pt;
        font-weight: 700;
        mso-font-charset: 134;
    }

    .qtk66 {
        mso-style-parent: styleQueTk;
        text-align: center;
        font-size: 16.0pt;
        font-weight: 700;
        mso-font-charset: 134;
    }

    .qtk67 {
        mso-style-parent: styleQueTk;
        text-align: left;
        vertical-align: top;
        mso-font-charset: 134;
    }

    .qtk68 {
        mso-style-parent: styleQueTk;
        text-align: center;
        mso-font-charset: 134;
    }

    .qtk69 {
        mso-style-parent: styleQueTk;
        text-align: center;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .qtk70 {
        mso-style-parent: styleQueTk;
        text-align: center;
        font-size: 10.0pt;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .qtk71 {
        mso-style-parent: styleQueTk;
        text-align: center;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .qtk72 {
        mso-style-parent: styleQueTk;
        text-align: left;
        white-space: normal;
        font-size: 10.0pt;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .qtk73 {
        mso-style-parent: styleQueTk;
        text-align: left;
        white-space: normal;
        font-size: 10.0pt;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .qtk74 {
        mso-style-parent: styleQueTk;
        text-align: center;
        font-size: 10.0pt;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .qtk75 {
        mso-style-parent: styleQueTk;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .qtk76 {
        mso-style-parent: styleQueTk;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .qtk77 {
        mso-style-parent: styleQueTk;
        text-align: left;
        vertical-align: top;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
        white-space: normal;
        word-break: break-all;

    }

    .qtk78 {
        mso-style-parent: styleQueTk;
        text-align: left;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .qtk79 {
        mso-style-parent: styleQueTk;
        text-align: left;
        vertical-align: top;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
    }

    .qtk80 {
        mso-style-parent: styleQueTk;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
    }

    .qtk81 {
        mso-style-parent: styleQueTk;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .qtk82 {
        mso-style-parent: styleQueTk;
        mso-font-charset: 134;
        border-bottom: .5pt solid windowtext;
    }

    .qtk83 {
        mso-style-parent: styleQueTk;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
        text-align: center;
    }

    .qtk84 {
        mso-style-parent: styleQueTk;
        text-align: center;
        font-size: 10.0pt;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .qtk85 {
        mso-style-parent: styleQueTk;
        mso-font-charset: 134;
        border-right: .5pt solid windowtext;
    }

    .qtk86 {
        mso-style-parent: styleQueTk;
        mso-font-charset: 134;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .qtk87 {
        mso-style-parent: styleQueTk;
        mso-font-charset: 134;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .qtk88 {
        mso-style-parent: styleQueTk;
        text-align: center;
        mso-font-charset: 134;
        border-bottom: .5pt solid windowtext;
    }


    .qtk89 {
        mso-style-parent: styleQueTk;
        text-align: left;
        vertical-align: top;
        white-space: normal;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }
</style>



// WEBPACK FOOTER //
// queryTkEvaluate.vue?4b87cfcc